<script setup lang="ts">
import { computed } from 'vue'
import type { TextBlock } from '../types'
import { cn } from '@/lib/utils'
import { renderMarkdown } from '@/lib/markdown'
import { sanitizeRichHtml } from '@/lib/htmlSanitizer'
import { processDateTimeExpressions } from '../utils/dateTime'
import {
  spacingClasses,
  textAlignClasses,
  textSizeClasses,
  textWeightClasses,
  textColorClasses,
} from '../utils/classes'

const props = defineProps<{ element: TextBlock }>()

const processedText = computed(() => processDateTimeExpressions(props.element.text))
const isMarkdownTextBlock = computed(() => props.element.type === 'TextBlock.Markdown')
const renderedMarkdownHtml = computed(() => sanitizeRichHtml(renderMarkdown(processedText.value).html))
</script>

<template>
  <p
    :class="cn(
      textSizeClasses[props.element.size ?? 'default'],
      textWeightClasses[props.element.weight ?? 'default'],
      textColorClasses[props.element.color ?? 'default'],
      spacingClasses[props.element.spacing ?? 'default'],
      textAlignClasses[props.element.horizontalAlignment ?? 'left'],
      props.element.isSubtle && 'text-muted-foreground',
      !props.element.wrap && 'truncate'
    )"
  >
    <span v-if="isMarkdownTextBlock" v-html="renderedMarkdownHtml" />
    <span v-else>{{ processedText }}</span>
  </p>
</template>
